// export const default NODE_API_BASE_URL = process.env.REACT_APP_NODE_API_BASE_URL;
const config = {
    NODE_API_BASE_URL: process.env.REACT_APP_NODE_API_BASE_URL,
    NODE_API_BASE_URL_V2: process.env.REACT_APP_NODE_API_BASE_URL_V2 || (process.env.REACT_APP_NODE_API_BASE_URL ? process.env.REACT_APP_NODE_API_BASE_URL.replace('/v1', '/v2') : 'http://localhost:3050/api/v2'),
};

export default config;